export default __webpack_public_path__ + "static/media/web_app_bg.6764696b.png";